<template>
	<header :class="[istabBar?'isFixed py-1':'py-2']">
		<div class="container">
			<div class="logo-div">
				<h1><a class="logo-div__a" href="javascript:void(0)" @click="hrefone"><img class="logo-div__img" src="@/assets/img/logo.png"></a></h1>
			</div>
			<nav class="d-lg-flex py-2" id="navBar">
				<ul class="menu mt-2 ml-auto">
					<li class="mr-lg-4 mr-3" :class="{active:0 == navbarIndex}">
						<a href="javascript:void(0)" @click="hrefone">首页</a>
					</li>
					<li class="mr-lg-4 mr-3" :class="{active:3 == navbarIndex}">
						<a href="javascript:void(0)" @click="hrefsix">AI Magic</a>
					</li>
					<li class="mr-lg-4 mr-3" :class="{active:1 == navbarIndex}">
						<a href="javascript:void(0)" @click="hreftwo">课程体系</a>
					</li>
					<li class="mr-lg-4 mr-3" :class="{active:2 == navbarIndex}">
						<a href="javascript:void(0)" @click="hreffive">机器人技术等级考试 </a>
					</li>
					<!--<li class="mr-lg-4 mr-3" :class="{active:4 == navbarIndex}">
						<a href="javascript:void(0)" @click="hreffour">青少年软件编程等级考试 </a>
					</li>-->
				</ul>
				<div class="login-center mt-2">
					<a v-if="!isLogin" class="login-center__a" href="javascript:void(0)" @click="login"><span class="fa fa-user-circle-o" aria-hidden="true"> <i>登录</i></span></a>
					<a v-else @mouseover="onOver" @mouseout="onOut"><img class="header__img rounded-circle" :src="sessionInfo.headimgurl">
						<div class="u-panel" v-show="isShow"><em style="right: 36px;"></em>
							<div class="content">
								<div class="u-info">
									<div class="u-pic"><img class="rounded-circle" :src="sessionInfo.headimgurl"></div>
									<div class="u-username">{{sessionInfo.wxNickName}}</div>
									<div class="u-rolename"><span class="badge badge-primary badge__1">{{sessionInfo.roleInfo.roleName}}</span></div>
								</div>
								<div class="u-bottom">
									<a v-if="sessionInfo.roleInfo.id == 3 || sessionInfo.roleInfo.id == 4" href="/itmswcn/maintain/main.html">进入后台中心</a>
									<a v-else href="javascript:void(0)" @click="toPersonCenter">进入个人中心</a>
									<a href="javascript:void(0)" @click="logout">退出登录</a>
								</div>
							</div>
						</div>
					</a>
				</div>
			</nav>
			<div class="clear"></div>
		</div>
		<div id="loginFrame" class="popup-effect">
			<div class="popup">
				<div data-role="tab" class="tab-login">
					<a role="weixin_qrcode" class="tab-item tab-item-weixin selected" href="javascript:void(0)" data-target="weixin_qrcode" @click="switchTab($event)">微信登录</a>
					<a role="user_login" class="tab-item tab-item-qq" href="javascript:void(0)" data-target="login_frame" @click="switchTab($event)">用户登录</a>
				</div>
				<div id="weixin_qrcode" class="tab-content py-2" style="display: block;"><iframe id="wx_login_frame" frameborder="0" scrolling="no" width="300px" height="368px" sandbox="allow-scripts allow-top-navigation allow-same-origin" src=""></iframe></div>

				<div class="login px-sm-5 mx-auto mw-100 py-2 tab-content" id="user_login" style="display: none;">
					<div class="text-center" style="padding: 18px 0;"><img src="../../../public/img/logo_foot.png" height="48px" /></div>
					<form action="common/loginMobilePhone" method="post" id="loginForm">
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-phone"></i></span>
							</div>
							<input type="text" class="form-control" id="mobilePhone" name="mobilePhone" placeholder="请输入手机号/用户名">
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-lock"></i></span>
							</div>
							<input type="password" class="form-control" id="password" name="password" autocomplete="off" placeholder="请输入密码">
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-check-square"></i></span>
							</div>
							<input type="text" class="form-control" id="authCode" name="authCode" autocomplete="off" maxlength="10" placeholder="请输入验证码">
							<img style="width: 100px;" id="authCodeImg" @click="getAuthCode" title="点击更换验证码" />
						</div>
						<div class="help-block text-center"></div>
						<div class="text-right" style="margin: 0 5px 5px 0;font-size: 14px;">
							<a href="javascript:void(0)" @click="forget">忘记密码?</a>
						</div>
						<input type="submit" class="btn btn-success btn-block" value="立即登录" />
					</form>
				</div>
				<a class="close" href="javascript:void(0)" @click="close">&times;</a>
			</div>
		</div>
		<div id="resetFrame" class="popup-effect">
			<div class="popup">
				<div class="login px-sm-5 mx-auto mw-100 py-2 tab-content" id="resetPwd">
					<div class="text-center" style="padding: 20px 0;"><img src="../../../public/img/logo_foot.png" height="48px" /></div>
					<form action="user/resetPwd" method="post" id="resetForm">
						<input type="hidden" name="smsTemplate" value="template02" />
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-phone"></i></span>
							</div>
							<input type="text" class="form-control" id="r_mobilePhone" name="recNum" placeholder="请输入手机号">
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-check-square"></i></span>
							</div>
							<input type="text" class="form-control" id="r_authCode" name="authCode" autocomplete="off" maxlength="10" placeholder="请输入验证码">
							<input type="button" class="btn btn-info" disabled="false" id="send-btn2" value="获取验证码" style="font-size: 12px;" @click="sendAuthCode('60')" />
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-lock"></i></span>
							</div>
							<input type="password" class="form-control" id="r_password" name="password" autocomplete="off" placeholder="请输入密码">
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-lock"></i></span>
							</div>
							<input type="password" class="form-control" id="rr_password" name="rePassword" autocomplete="off" placeholder="请再次输入密码">
						</div>
						<div class="help-block text-center"></div>
						<input type="submit" class="btn btn-success btn-block" value="立即重置" />
					</form>
				</div>
				<a class="close" href="javascript:void(0)" @click="close1">&times;</a>
			</div>
		</div>
		<div id="bindingFrame" class="popup-effect">
			<div class="popup">
				<div class="login px-sm-5 mx-auto mw-100 py-2 tab-content" id="binding">
					<div class="text-center" style="padding: 20px 0;"><img src="../../../public/img/logo_foot.png" height="48px" /></div>
					<form action="common/binding" method="post" id="bindingForm">
						<input type="hidden" name="smsTemplate" value="template01" />
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-phone"></i></span>
							</div>
							<input type="text" class="form-control" id="b_mobilePhone" name="recNum" placeholder="请输入手机号绑定用户">
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-check-square"></i></span>
							</div>
							<input type="text" class="form-control" id="b_authCode" name="authCode" autocomplete="off" maxlength="10" placeholder="请输入验证码">
							<input type="button" class="btn btn-info" disabled="false" id="send-btn" value="获取验证码" style="font-size: 12px;" @click="sendAuthCode2('60')" />
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-lock"></i></span>
							</div>
							<input type="password" class="form-control" id="b_password" name="password" autocomplete="off" placeholder="请输入密码">
						</div>
						<div class="help-block text-center"></div>
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text"><i class="fa fa-lock"></i></span>
							</div>
							<input type="password" class="form-control" id="bb_password" name="rePassword" autocomplete="off" placeholder="请再次输入密码">
						</div>
						<div class="help-block text-center"></div>
						<input type="submit" class="btn btn-success btn-block" value="立即绑定" />
					</form>
				</div>
				<a class="close" href="javascript:void(0)" @click="close2">&times;</a>
			</div>
		</div>
		<div class="gotop-box">
			<i @click="gotop" class="icon topIcon"></i>
		</div>
	</header>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'SmallHeader',
		props: ['navbarIndex'],
		data() {
			return {
				sessionInfo: "",
				isLogin: false,
				isShow: false,
				isBind: false,
				istabBar: false
			}
		},
		methods: {
			// 添加一个方法 兼容
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// 固定导航栏
				let navBar = document.querySelector("#navBar")
				let mainPart = document.querySelector(".banner")
				let height = navBar.offsetHeight + 23
				if(scrollTop > 90) {
					this.istabBar = true
					mainPart.style.paddingTop = height + "px"
				} else {
					this.istabBar = false
					mainPart.style.paddingTop = "0px"
				}
			},
			gotop() { // 点击回顶按钮 返回顶部
				$("html,body").animate({
					scrollTop: 0
				}, 500)
			},
			hrefone() {
				this.$router.push({
					path: '/'
				})
			},
			hreftwo() {
				this.$router.push({
					path: '/course'
				})
			},
			hrefthree() {
				if(this.$store.state.roleId == 2) {
					this.$router.push({
						path: '/teach/center'
					})
				} else {
					this.$router.push({
						path: '/learn/center'
					})
				}
			},
			hreffour() {
				this.$router.push({
					path: '/cpp'
				})
			},
			hreffive() {
				this.$router.push({
					path: '/robot'
				})
			},
			hrefsix() {
				this.$router.push({
					path: '/magic/01'
				})
			},
			toPersonCenter() {
				/*if(this.$store.state.roleId == 1) {
					this.$router.push({
						path: '/center/stCenter'
					})
				} else if(this.$store.state.roleId == 2) {
					this.$router.push({
						path: '/center/tcCenter'
					})
				}*/
				if(this.$store.state.roleId == 2) {
					this.$router.push({
						path: '/center/tcCenter'
					})
				}
			},
			onOver() {
				this.isShow = true
			},
			onOut() {
				this.isShow = false
			},
			login() {
				var $uri = "https://open.weixin.qq.com/connect/qrconnect?appid=wx7d88d30c3d4b06b8&redirect_uri=https://itmsw.com/itmswcn/common/wechat/getCode&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e&popup=0&href=https://mat1.gtimg.com/sports/sportAppWeb/css/iframe_login_wx.css#wechat_redirect";
				document.getElementById("wx_login_frame").src = $uri;
				$("#loginFrame").css({
					"opacity": 1,
					"visibility": "visible"
				});
			},
			close() {
				document.getElementById("wx_login_frame").src = "";
				$("#loginFrame").css({
					"opacity": 0,
					"visibility": "hidden"
				});
			},
			close1() {
				$("#resetFrame").css({
					"opacity": 0,
					"visibility": "hidden"
				});
			},
			close2() {
				$("#bindingFrame").css({
					"opacity": 0,
					"visibility": "hidden"
				});
			},
			forget() {
				this.close()
				$("#resetFrame").css({
					"opacity": 1,
					"visibility": "visible"
				});
			},
			switchTab(event) {
				var el = event.currentTarget;
				$(el).addClass("selected").siblings().removeClass("selected");
				$("#" + $(el).attr("role")).show().siblings(".tab-content").hide();
				if($(el).data("target") == "login_frame") {
					this.getAuthCode()
				}
			},
			getAuthCode() {
				axios.get('/itmswcn/validateCode/create', {
						responseType: "arraybuffer"
					})
					.then(res => {
						return 'data:image/png;base64,' + btoa(
							new Uint8Array(res.data)
							.reduce((data, byte) => data + String.fromCharCode(byte), '')
						);
					}).then(function(res) {
						$("#authCodeImg").attr("src", res);
						$("#authCode").val("");
						$("#authCode").focus();
					})
			},
			sendAuthCode(seconds) {
				$.getJSON("/itmswcn/common/sendAuthCode?recNum=" + $("#r_mobilePhone").val() + "&smsTemplate=template02")
				this.countdown(seconds)
			},
			countdown(seconds) {
				var _this = this
				if(seconds == 0) {
					$("#send-btn2").attr("disabled", false);
					$("#send-btn2").val("获取验证码");
					return;
				} else {
					$("#send-btn2").attr("disabled", true);
					$("#send-btn2").val("重新发送(" + seconds + ")");
					seconds--;
					setTimeout(function() {
						_this.countdown(seconds);
					}, 1000);
				}
			},
			sendAuthCode2(seconds) {
				$.getJSON("/itmswcn/common/sendAuthCode?recNum=" + $("#b_mobilePhone").val() + "&smsTemplate=template01")
				this.countdown2(seconds)
			},
			countdown2(seconds) {
				var _this = this
				if(seconds == 0) {
					$("#send-btn").attr("disabled", false);
					$("#send-btn").val("获取验证码");
					return;
				} else {
					$("#send-btn").attr("disabled", true);
					$("#send-btn").val("重新发送(" + seconds + ")");
					seconds--;
					setTimeout(function() {
						_this.countdown2(seconds);
					}, 1000);
				}
			},
			getSessionInfo() {
				axios.get('/itmswcn/user/session')
					.then(this.getSessionInfoSucc)
			},
			getSessionInfoSucc(res) {
				res = res.data
				if(res.code == 100) {
					this.isLogin = true
					this.sessionInfo = res.data
					if(res.data.unionid && !res.data.ppOpenid) {
						this.isBind = true
					}
					if(!this.sessionInfo.headimgurl.match(RegExp(/https/))) {
						this.sessionInfo.headimgurl = this.sessionInfo.headimgurl.replace("http", "https")
					}
					this.$store.commit('setSessionInfo', this.sessionInfo)
					this.$store.commit('setRole', this.sessionInfo.roleInfo.id)
					this.getAuth()
					//					this.bindWechat()
				} else {
					this.isLogin = false
				}
				this.$store.commit('setLoginFlag', this.isLogin)
				this.queryScope()
			},
			getAuth() {
				axios.get('/itmswcn/userClass/lives/auth')
					.then(this.getAuthSucc)
			},
			getAuthSucc(res) {
				res = res.data
				if(res.code == 100) {
					this.$store.commit('setAuthcode', 10)
				} else if(res.code == 601) {
					this.$store.commit('setAuthcode', 1)
				} else if(res.code == 602) {
					this.$store.commit('setAuthcode', 2)
				} else if(res.code == 603) {
					this.$store.commit('setAuthcode', 3)
				}
			},
			logout() {
				$.confirm({
					title: '',
					content: '<span class="itmsw_ft_1"><i class="fa fa-check-square-o"></i> 您确定要退出码速编程网吗？</span>',
					theme: 'modern',
					closeIcon: false,
					animation: 'scale',
					type: 'blue',
					boxWidth: '380px',
					useBootstrap: false,
					backgroundDismiss: false,
					buttons: {
						yes: {
							text: '确认', // text for button
							btnClass: 'itmsw_bt_confirm_1', // class for the button
							keys: ['y'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(yesButton) {
								axios.get('/itmswcn/common/util/logout')
									.then(function(res) {
										if(res.data.code == 100) {
											window.location = "/";
										}
									});
							}
						},
						no: {
							text: '取消', // text for button
							btnClass: 'itmsw_bt_confirm_2', // class for the button
							keys: ['n'], // keyboard event for button
							isHidden: false, // initially not hidden
							isDisabled: false, // initially not disabled
							action: function(noButton) {}
						}
					}
				});
			},
			validate() {
				var _this = this
				//字母和数字的验证
				$.validator.addMethod("chrnum", function(value, element) {
					var chrnum = /^([a-zA-Z0-9_]+)$/;
					return this.optional(element) || chrnum.test(value);
				}, "只能输入数字、字母和下划线");

				// 必须字母和数字的验证
				$.validator.addMethod("alnum", function(value, element) {
					var alnum = /^[A-Za-z].*[0-9].*[A-Za-z]|[A-Za-z].*[0-9]|[0-9].*[A-Za-z]|[0-9].*[A-Za-z].*[0-9]+$/;
					return this.optional(element) || alnum.test(value);
				}, "必须为字母和数字的组合");

				// 对手机号码的验证
				$.validator.addMethod("mobilePhone", function(value, element) {
					var mobilePhone = /^(13[0-9]|14[579]|15[012356789]|166|17[35678]|18[0-9]|19[89])\d{8}$/;
					var result = this.optional(element) || mobilePhone.test(value);
					if(!result) {
						$("#send-btn").attr("disabled", true);
					}
					return result;
				}, "请输入正确的手机号码");

				//ajax对手机唯一性验证
				$.validator.addMethod("mobilePhoneValidate", function(value, element) {
					var uniqueFlag = false;
					$.ajax({
						type: "GET",
						url: "/itmswcn/user/queryByMobilePhone?mobilePhone=" + $("#b_mobilePhone").val(),
						dataType: "json",
						async: false,
						success: function(data) {
							if(data.code == 100) {
								uniqueFlag = true;
								$("#send-btn").attr("disabled", false);
							} else {
								uniqueFlag = false;
								$("#send-btn").attr("disabled", true);
							}
						}
					});
					return uniqueFlag;
				}, "该手机号码已被注册");

				$.validator.addMethod("mobilePhoneValidate2", function(value, element) {
					var uniqueFlag = false;
					$.ajax({
						type: "GET",
						url: "/itmswcn/user/queryByMobilePhone?mobilePhone=" + $("#r_mobilePhone").val(),
						dataType: "json",
						async: false,
						success: function(data) {
							if(data.code != 100) {
								uniqueFlag = true;
								$("#send-btn2").attr("disabled", false);
							} else {
								uniqueFlag = false;
								$("#send-btn2").attr("disabled", true);
							}
						}
					});
					return uniqueFlag;
				}, "该手机号码不存在");

				$("#loginForm").validate({
					submitHandler: function(form) {
						$.getJSON("/itmswcn/" + $(form).attr("action"), $(form).serialize(), function(data) {
							if(data.code == "100") {
								window.location = "/"
							} else {
								$("#loginForm").find(".help-block").last().html("<label>" + data.msg + "</label>").show().fadeOut(5000);
							}
						});
					},
					rules: {
						'mobilePhone': {
							required: true,
							chrnum: true
						},
						'authCode': {
							required: true,
							minlength: 4,
							maxlength: 4
						},
						'password': {
							required: true,
							alnum: true,
							chrnum: true,
							minlength: 6,
							maxlength: 16
						}
					},
					messages: {
						mobilePhone: {
							required: "用户名不能为空"
						},
						authCode: {
							required: "验证码不能为空",
							minlength: ("验证码不能小于{0}个字符"),
							maxlength: jQuery.format("验证码不能大于{0}个字符")
						},
						password: {
							required: "密码不能为空",
							minlength: ("密码不能小于{0}个字符"),
							maxlength: jQuery.format("密码不能大于{0}个字符")
						}
					},
					errorPlacement: function(error, element) {
						element.parent().next().html(error);
					}
				});

				$("#resetForm").validate({
					submitHandler: function(form) {
						$.getJSON("/itmswcn/" + $(form).attr("action"), $(form).serialize(), function(data) {
							if(data.code == "100") {
								_this.close1()
								_this.login()
							} else {
								$("#resetForm").find(".help-block").last().html("<label>" + data.msg + "</label>").show().fadeOut(5000);
							}
						});
					},
					rules: {
						'recNum': {
							required: true,
							mobilePhone: true,
							mobilePhoneValidate2: true
						},
						'authCode': {
							required: true,
							minlength: 6,
							maxlength: 6
						},
						'password': {
							required: true,
							alnum: true,
							chrnum: true,
							minlength: 6,
							maxlength: 16
						},
						'rePassword': {
							required: true,
							equalTo: "#r_password"
						}
					},
					messages: {
						recNum: {
							required: "手机不能为空"
						},
						authCode: {
							required: "验证码不能为空",
							minlength: ("验证码不能小于{0}个字符"),
							maxlength: jQuery.format("验证码不能大于{0}个字符")
						},
						password: {
							required: "登录密码不能为空",
							minlength: ("登录密码不能小于{0}个字符"),
							maxlength: jQuery.format("密码不能大于{0}个字符")
						},
						rePassword: {
							required: "确认登录密码不能为空",
							equalTo: "两次输入登录密码不一致"
						}
					},
					errorPlacement: function(error, element) {
						element.parent().next().html(error);
					}
				});

				$("#bindingForm").validate({
					submitHandler: function(form) {
						$.getJSON("/itmswcn/" + $(form).attr("action"), $(form).serialize(), function(data) {
							if(data.code == "100") {
								window.location = "/";
							} else if(data.code == "203") {
								_this.close2()
								_this.login()
							} else {
								$("#bindingForm").find(".help-block").last().html("<label>" + data.msg + "</label>").show().fadeOut(5000);
							}
						});
					},
					rules: {
						'recNum': {
							required: true,
							mobilePhone: true,
							mobilePhoneValidate: true
						},
						'authCode': {
							required: true,
							minlength: 6,
							maxlength: 6
						},
						'password': {
							required: true,
							alnum: true,
							chrnum: true,
							minlength: 6,
							maxlength: 16
						},
						'rePassword': {
							required: true,
							equalTo: "#b_password"
						}
					},
					messages: {
						recNum: {
							required: "手机不能为空"
						},
						authCode: {
							required: "验证码不能为空",
							minlength: ("验证码不能小于{0}个字符"),
							maxlength: jQuery.format("验证码不能大于{0}个字符")
						},
						password: {
							required: "登录密码不能为空",
							minlength: ("登录密码不能小于{0}个字符"),
							maxlength: jQuery.format("密码不能大于{0}个字符")
						},
						rePassword: {
							required: "确认登录密码不能为空",
							equalTo: "两次输入登录密码不一致"
						}
					},
					errorPlacement: function(error, element) {
						element.parent().next().html(error);
					}
				});
			},
			queryScope() {
				var uri = window.location.search
				var pair = uri.split("=")[1]
				if(pair == "binding" && !this.isLogin) {
					this.binding()
				}

				if(this.$route.query.scope == "teach" && this.isLogin) {
					document.getElementById('teachlink').scrollIntoView()
				}
			},
			binding() {
				$("#bindingFrame").css({
					"opacity": 1,
					"visibility": "visible"
				});
			},
			bindWechat() {
				if(this.isBind) {
					$.getJSON("/itmswcn/userQrcode/myQrcode", function(res) {
						$.alert({
							title: '<span class=\'itmsw_ft_1\'>请用微信扫描二维码完成账号绑定</span>',
							content: '<img src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket + '" style="width:70%">',
							theme: 'modern',
							closeIcon: false,
							animation: 'scale',
							type: 'blue',
							animationBounce: 1.5,
							boxWidth: '466px',
							useBootstrap: false,
							backgroundDismiss: false,
							buttons: {
								yes: {
									text: '确定', // text for button
									btnClass: 'itmsw_bt_confirm_1', // class for the button
									keys: ['y'], // keyboard event for button
									isHidden: false, // initially not hidden
									isDisabled: false, // initially not disabled
									action: function(yesButton) {}
								}
							}
						});
					});
				}
			}
		},
		mounted() {
			this.getSessionInfo()
			this.validate()
			window.addEventListener('scroll', this.handleScroll); // Dom树加载完毕
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) // 销毁页面时清除
		}
	}

	window.onscroll = function() {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
		const goTop = document.querySelector('.gotop-box')
		if(goTop) {
			if(scrollTop > 90) {
				goTop.style.display = 'block'
			} else {
				goTop.style.display = 'none'
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/common/SmallHeader.scss';
</style>